<template>
  <main class="container">
    <div class="breadCrumb_modern_box">
      <div class="container">
        <ul class="breadcrumb">
          <li class="crumb_path">
            <a href="/">{{ this.$t("home12") }}</a>
          </li>
          <li class="active">
            <h1 class="breadcrumb_h1">{{ this.$t("machinery12") }}</h1>
          </li>
        </ul>
      </div>
    </div>
    <div class="main-acticle">
      <div class="product">
        <div class="pro-prolay">
          <div class="col-3 pro-list">
            <div>
              <div class="pro-box" data-tilt>
                <a href="/machinery/zm10aa" title="搓牙機" target="_top">
                  <div class="pro-border">
                    <p class="photo" style="background-image: url(../assets/img/MachineImg/ThreadRolling_logo.svg);">
                      <img src="../assets/product-blank.png" alt="搓牙機"/>
                      <div class="pro-info">
                        <h3>{{ this.$t("zm10aa12") }}</h3>
                      </div>
                    </p>
                  </div>
                </a>
              </div>
            </div>
            <div>
              <div class="pro-box" data-tilt>
                <a href="/machinery/zm02aa" title="捲釘機" target="_top">
                  <div class="pro-border">
                    <p class="photo" style="background-image: url(../assets/img/MachineImg/VolumeNail_logo.svg);">
                      <img src="../assets/product-blank.png" alt="捲釘機"/>
                      <div class="pro-info">
                        <h3>{{ this.$t("zm02aa12") }}</h3>
                      </div>
                    </p>
                  </div>
                </a>
              </div>
            </div>
            <div>
              <div class="pro-box" data-tilt>
                <a href="/machinery/cn_nc_l30" title="CNC機器與自動進料" target="_top">
                  <div class="pro-border">
                    <p class="photo" style="background-image: url(../assets/img/MachineImg/CNC機器與自動進料_logo.svg);">
                      <img src="../assets/product-blank.png" alt="CNC機器與自動進料"/>
                      <div class="pro-info">
                        <h3>{{ this.$t("cn_nc_l30") }}</h3>
                      </div>
                    </p>
                  </div>
                </a>
              </div>
            </div>
            <div>
              <div class="pro-box" data-tilt>
                <a href="/machinery/assemblemachine" title="組立機" target="_top">
                  <div class="pro-border">
                    <p class="photo" style="background-image: url(../assets/img/MachineImg/空機台_logo.svg);">
                      <img src="../assets/product-blank.png" alt="組立機"/>
                      <div class="pro-info">
                        <h3>{{ this.$t("assemblemachine12") }}</h3>
                      </div>
                    </p>
                  </div>
                </a>
              </div>
            </div>
            <div>
              <div class="pro-box" data-tilt>
                <a href="/machinery/cn_dr" title="鑽孔機" target="_top">
                  <div class="pro-border">
                    <p class="photo" style="background-image: url(../assets/img/MachineImg/鑽孔機_logo.svg);">
                      <img src="../assets/product-blank.png" alt="鑽孔機"/>
                      <div class="pro-info">
                        <h3>{{ this.$t("cn_dr") }}</h3>
                      </div>
                    </p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "Machinery",
  mounted(){
    VanillaTilt.init(document.querySelectorAll('.pro-box'),{
      max:  180,
    });
  },
};
</script>

<style scoped lang="stylus">
.breadCrumb_modern_box
  background-color: transparent;
  margin-left:  11.5vmin;
  margin-right: 60vmin;
  margin-top: -7vmin;
  margin-bottom:  10vmin;
  width:    100vmin;
  position: absolute;
  left: 0vmin;
  text-align: left;

.container
  max-width:  100%;
  margin-top: inherit;

ul
  margin-top: 0;
  margin-bottom:  10px;

.breadcrumb
  padding:  8px 15px;
  margin-bottom:  20px;
  list-style: none;
  background-color: #f5f5f5;
  border-radius:  4px;

@media (min-width:  326px)
  .breadcrumb
    background-color: rgba(0,0,0,0);
    padding:  15px 0px;
    margin-top: 5vmin;

.breadcrumb>li
  display:  inline-block;

.crumb_path>a
  margin: 0vmin 3vmin

a
  background-color: transparent;
  color:  #337ab7;
  text-decoration:  none;
  font-size:  3vmin;
  margin: 5vmin 5vmin;

.breadcrumb>.active
  color:  #000;

.h1 .h2 .h3 .h4 .h5 .h6, h1, h2, h3, h4, h5, h6
  font-family:  inherit;
  font-weight:  500;
  line-height:  1.1;
  color:  inherit;
  word-wrap: break-word;
  width:  37vmin;

.breadcrumb_h1
  font-size:  initial;
  display:  inline;
  color:  inherit;
  font-family:  inherit;

.breadcrumb .active h1.breadcrumb_h1
  font-size:  3vmin;
  margin-right: 3vmin;

.breadcrumb>li+li:before
  color:  #000;
  content:  "/\00a0"

.col-3
  position: relative;
  width:  100%;
  min-height: 1px;
  padding: 0vmin 20vmin;
  display:  flex;
  flex-direction: inherit;
  flex-wrap:  wrap;
  align-content:  center;
  justify-content:  space-evenly;

main
  overflow: visible;
  margin: 2em 0;

.main-acticle
  margin: 10vmin 0vmin;

#product #pro-prolay .pro-list >div
  widows: 25%;
  float:  left;

#product #pro-prolay .pro-box
  position: relative;
  background: linear-gradient(to right, rgba(255,255,255,1) 2%, rgb(255,255,255) 100%);
  z-index:  1;

#product #pro-prolay .pro-box a
  position: absolute;
  top:  0;
  left: 0;
  width:  100%;
  height: 100%;
  z-index:  3;

#product #pro-prolay .pro-box pro-border
  position: relative;
  overflow: hidden;
  transition: .3s ease-in-out;
  -o-transition: .3s ease-in-out;
  -moz-transition: .3s ease-in-out;
  -webkit-transition: .3s ease-in-out;

#product #pro-prolay .pro-box pro-border:before
  content:  '>';
  display:  block;
  position: absolute;
  z-index:  2;
  bottom: 8px;
  right:  5px;
  color:  #fff;
  transition: .3s ease-in-out;
  opacity:  0;
  right:  0;

.photo
  height: 80%;
  background-repeat: no-repeat;
  background-position:  center;
  background-size:  contain;
  transition: .3s ease-in-out;
  -o-transition: .3s ease-in-out;
  -moz-transition: .3s ease-in-out;
  -webkit-transition: .3s ease-in-out;

.photo img
  position: relative;
  width:  auto;
  height: auto;

img:before
  content:  '';
  display:  block;
  position: static;
  background: #000;

#product #pro-prolay .pro-box .pro-info
  position: absolute;
  top:  0;
  padding:  25px;
  font-size:  11pt;
  width:  calc(100% - 50px);

#product #pro-prolay .pro-box .pro-info h3
  margin-bottom:  10px;
  font-size:  10vmin;
  line-height:  20vmin;
  color:  #000;

</style>
